import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  map,
  share,
  catchError,
  withLatestFrom,
  mergeMap,
  repeat,
} from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { TraderInfoAction } from './trader.action';
import { HttpHeaders } from '@angular/common/http';
import { HttpService } from '@toro/common/shared/services/http/http.service';
import { SettingsService } from '@toro/common/shared/services/settings/settings.service';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { UsersState } from '@toro/common/shared/state-management/users/users.reducer';

@Injectable()
export class TraderInfoEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private httpService: HttpService,
    private settings: SettingsService,
  ) {}

  traderInfo = createEffect(() =>
    this.actions$.pipe(
      ofType(TraderInfoAction.traderInfo),
      withLatestFrom(this.store.select((authStore) => authStore.authentication)),
      mergeMap(([, auth]) => {
      const apiUrl = this.settings.getConfigurationKeyValue('backend');
      const isLogged = !!(auth.currentUser && auth.currentUser.token);
      return this.httpService.get<any>(`${apiUrl.api}/trader`, this._createHeaders(auth, isLogged))
        .pipe(
          map((traderResponse: any) => {
            if (traderResponse) {
              return {
                type: TraderInfoAction.traderInfoSuccess,
                payload: traderResponse
              };
            } else {
              return { type: TraderInfoAction.traderInfoError, payload: {} };
            }
          })
        );
    }),
    catchError((error) => of({ type: TraderInfoAction.traderInfoError, payload: error })),
    repeat(),
    share()
  ));

  private _createHeaders(userData: UsersState, logged: boolean = false) {
    if (!logged) {
      return new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8',
        'X-SessionID': `${userData.sessionID}`,
      });
    } else {
      return new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${userData.currentUser.token}`,
      });
    }
  }
}
